import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from "./Community.module.scss"; // SCSS module import
import { getMembers } from "../../utils/network/Crud";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import BackButton from "../../Components/BackButton";
import { FaCrown, FaUsers, FaCode } from "react-icons/fa6";
import useTranslation from "../../utils/i18n/useTranslation";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.07 } },
};

export const Community = () => {
  const [allMembers, setAllMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const getAllMembersData = async () => {
    try {
      setLoading(true);
      const result = await getMembers();
      if (result) {
        setAllMembers(result?.data);
      }
    } catch (error) {
      toast.error("Something went wrong !", { autoClose: 1200 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllMembersData();
  }, []);
  if (loading) {
    return (
      <div className={styles.loaderContainer}>
        <ThreeDots
          visible={true}
          height="80"
          width="80"
          color="rgb(251,157,71)"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }
  const shuffleArray = (array) => {
    let shuffledArray = array.slice();
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ];
    }
    return shuffledArray;
  };

  const shuffledMembers = shuffleArray(
    allMembers?.filter((elem) => !elem?.important) || []
  );

  if (!allMembers?.length) {
    return (
      <div className={styles["members-page"]}>
        <BackButton title={t("communityTitle")} />
        <div className={styles["empty-state"]}>
          <FaUsers className={styles["empty-icon"]} />
          <h3>{t("communityEmptyTitle")}</h3>
          <p>{t("communityEmptyBody")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles["members-page"]}>
      <BackButton title={t("communityTitle")} />
      {/* CEO and Managers Section */}
      <motion.section
        className={styles["ceo-managers"]}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        variants={staggerContainer}
      >
        {allMembers?.some((elem) => elem?.important) && (
          <h2>
            <FaCrown className={styles["section-icon"]} /> {t("communityLeaders")}
          </h2>
        )}
        <div className={styles["member-cards"]}>
          {allMembers
            ?.filter((elem) => elem?.important)
            .sort((a, b) => a?.index - b?.index)
            .map((member, index) => (
              <motion.div
                key={index}
                className={`${styles["member-card"]} ${styles["ceo-manager"]}`}
                variants={fadeUp}
                whileHover={{ y: -6 }}
              >
                <img src={member.image} alt={member.name} />
                <h3>{member.name}</h3>
                <p>{member.designation}</p>
              </motion.div>
            ))}
        </div>
      </motion.section>

      {/* Common People Section */}
      <motion.section
        className={styles["common-people"]}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
        variants={staggerContainer}
      >
        {shuffledMembers.length > 0 && (
          <h2>
            <FaUsers className={styles["section-icon"]} /> {t("communityMembers")}
          </h2>
        )}
        <div
          className={`${styles["member-cards"]} ${styles["member-card-other-container"]}`}
        >
          {shuffledMembers.map((member, index) => (
            <motion.div
              key={index}
              className={`${styles["member-card"]} ${styles["member-card-other"]}`}
              variants={fadeUp}
              whileHover={{ y: -6 }}
            >
              <img src={member.image} alt={member.name} />
              <h3>{member.name}</h3>
              <p>{member.designation}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Developer Card Section */}
      <motion.section
        className={styles["developer-section"]}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
      >
        <h2>
          <FaCode className={styles["section-icon"]} /> {t("communityDevelopedBy")}
        </h2>
        <div className={styles["developer-card"]}>
          <img
            src={require("../../assets/profile.jpg")} // Developer image
            alt="Developer"
            className={styles["developer-photo"]}
          />
          <div className={styles["developer-info"]}>
            <h3>Prateek Shukla</h3> {/* Developer Name */}{" "}
            <p>Software Engineer L2 at Think Future Technologies</p>{" "}
            <p>
              <b>Email:</b> prateekshukla130@gmail.com
            </p>{" "}
            {/* Developer Email */}
            <p>
              <b>Website:</b>{" "}
              <a
                href="https://portfolio-15a4a.firebaseapp.com/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["developer-link"]}
              >
                <b>Click Here</b>
              </a>
            </p>
          </div>
        </div>
      </motion.section>
    </div>
  );
};
